import { useState, useEffect, CSSProperties } from "react";
import Layout from "../../Layout";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import ReportCards from "Components/ReportCards";
import { useNavigate } from "react-router-dom";

import {
  ReportElementBanner,
  ReportContainerTitle,
  ReportElementBannerTitle,
  ReportElementContainer,
  BackButton,
  ReportContainerSelector,
  IconListButton,
  Label,
  InputSelect,
  ReportElementListContainer,
  ReportContainerSelect,
} from "./styled.components";

import "../../assets/css/reportes/index.css";
import { requestReports, setFavorite, unsetFavorite } from "actions/report";
import { IReport } from "Interfaces/IReport";
import { Fade, Icon } from "@mui/material";
import ReportRows from "Components/ReportRows";
import { BuildMyReports, findInMenu, reportTypeMap } from "utils";

const Reportes = () => {
  const [reports, setReports] = useState<any[]>([]);
  const [reportMenu, setReportMenu] = useState<IReport>({});
  const [isSelected, setIsSelected] = useState(false);
  const [fadeReport, setFadeReport] = useState(false);
  const [reportsSelect, setReportsSelect] = useState<any[]>([]);
  const [displayList, setDisplayList] = useState(true);
  const [iconList, setIconList] = useState(true);
  const [reportsSelected, setReportsSelected] = useState(-2);
  const { modules } = useSelector((state: any) => state.user);
  const reportsData = useSelector((state: any) => state.reportsData);

  const { bannerReport } = useSelector((state: any) => state.theme);
  const { catalogs } = useSelector((state: any) => state.theme);
  const { context } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);
  const dispatch: Dispatch = useDispatch();

  const history = useNavigate();

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: context?.background,
    color: "#ffffff",
  };

  const handleBackClick = (e: any) => {
    setReportMenu({});
    setReportsSelected(-2);
    setIsSelected(false);
    setFadeReport(false);
  };

  const handleOnChangeReports = (e: any) => {
    if (e.target.value != -2) {
      const selected = reportsSelect.filter(
        (report: any) => report.idVista == e.target.value
      );
      setReportMenu(selected[0]);
      setReportsSelected(e.target.value);
      setIsSelected(true);
      setFadeReport(true);
    } else {
      setReportMenu({});
      setReportsSelected(-2);
      setIsSelected(false);
      setFadeReport(false);
    }
  };


  const handleOnClick = (e: any) => {
    if (!e.isSelected) {
      setReportMenu(e);
      setIsSelected(true);
      setFadeReport(true);
    } else {
      const type = reportTypeMap[e.idTipoReporte];
      const url = `../../report/${e.idVista}/${type}`;
      history(url);
    }
  };

  const handleFavoriteOnClick = async (e: any) => {
    if (!e.favorito) {
      setFavorite(e).then(async (res) => {
        if (res) {
          await setFavoriteState(e);
          handleReports();
        }
      });
    } else {
      unsetFavorite(e).then(async (res) => {
        if (res) {
          await setFavoriteState(e);
          handleReports();
        }
      });
    }
  };

  const setFavoriteState = async (itemFavorite: any) => {
    const temp: any = reportMenu;
    let result = !reportsData.reports ? null : reportsData.reports;
    result[0].hijos.forEach((report: any, index: number) => {
      if (temp.idVista == report.idVista) {
        report.hijos.forEach((reportChild: any, indexChild: number) => {
          if (itemFavorite.idVista == reportChild.idVista) {
            result[0].hijos[index].hijos[indexChild].favorito =
              !result[0].hijos[index].hijos[indexChild].favorito;
          }
        });
      }
    });
    await dispatch({
      type: "SET_REPORTS",
      payload: result,
    });
    await requestReports().then((res) => {
      dispatch({
        type: "SET_REPORTS",
        payload: res,
      });
    });
  };

  const handleLinkOnClick = (e: any) => {
    window.open(`../../report/${e.idVista}/${e.tipoReporte.replace(" ", "")}`);
  };

  const handleReports = async () => {
    let result = !reportsData.reports ? null : reportsData.reports;
    if (!result) {
      result = await requestReports();
    }

    const items: any =
      result?.[0]?.hijos.filter((report: any) => report.idTipoVista === 2) ||
      [];

    const reports = BuildMyReports(modules, items);
    const favorites = {
      idVista: -1,
      descripcionMenu: "Favoritos",
      hijos: getSelectorReports(true, reports),
    };
    const recents = {
      idVista: 0,
      descripcionMenu: "Recientes",
      hijos: getSelectorReports(false, reports),
    };
    items.unshift(recents);
    items.unshift(favorites);
    items.unshift({
      idVista: -2,
      descripcionMenu: "Seleccionar",
      hijos: [],
    });

    setReports(reports);

    if (isSelected) {
      const selected = items.filter(
        (report: any) => report.idVista == reportMenu.idVista
      );
      setReportMenu(selected[0]);
    }
    setReportsSelect(reports);
  };

  const getSelectorReports = (favorite: boolean, reports: any) => {
    let childs: any = [];
    reports.forEach((report: any) => {
      report.hijos.forEach((child: any) => {
        if (favorite ? child.favorito : child.reciente) {
          childs.unshift(child);
        }
      });
    });
    return childs;
  };

  useEffect(() => {
    handleReports();
  }, []);

  const renderSectionReport = () => {
    if (isSelected) {
      return iconList ? (
        <Fade in={fadeReport} timeout={500}>
          <ReportElementContainer bg={context?.background}>
            <ReportCards
              dataCards={reportMenu?.hijos?.filter((item: any) =>
                findInMenu(item, modules)
              )}
              isSelected={isSelected}
              handleOnClick={handleOnClick}
              handleFavoriteOnClick={handleFavoriteOnClick}
              handleLinkOnClick={handleLinkOnClick}
            />
          </ReportElementContainer>
        </Fade>
      ) : (
        <Fade in={fadeReport} timeout={500}>
          <ReportElementListContainer bg={context?.background}>
            <ReportRows
              dataRows={reportMenu?.hijos?.filter((item: any) =>
                findInMenu(item, modules)
              )}
              isSelected={isSelected}
              handleOnClick={handleOnClick}
              handleFavoriteOnClick={handleFavoriteOnClick}
              handleLinkOnClick={handleLinkOnClick}
            />
          </ReportElementListContainer>
        </Fade>
      );
    }

    return iconList ? (
      <ReportElementContainer bg={context?.background}>
        <ReportCards
          dataCards={reports}
          isSelected={isSelected}
          handleOnClick={handleOnClick}
          handleFavoriteOnClick={handleFavoriteOnClick}
          handleLinkOnClick={handleLinkOnClick}
        />
      </ReportElementContainer>
    ) : (
      <ReportElementListContainer bg={context?.background}>
        <ReportRows
          dataRows={reports}
          isSelected={isSelected}
          handleOnClick={handleOnClick}
          handleFavoriteOnClick={handleFavoriteOnClick}
          handleLinkOnClick={handleLinkOnClick}
        />
      </ReportElementListContainer>
    );
  };

  return (
    <Layout theme={styles}>
      <div className={"report-container"}>
        <ReportElementBanner
          bgImagen={
            bannerReport
              ? `${process.env.PUBLIC_URL}${bannerReport}`
              : "/commons/bg_profile.png"
          }
          selectOpen={displayList}
        >
          <ReportContainerTitle>
            <ReportElementBannerTitle textColor={catalogs?.textTitleColor}>
              {!isSelected ? "Reportes" : reportMenu.descripcionMenu}
            </ReportElementBannerTitle>
          </ReportContainerTitle>
          <ReportContainerSelector>
            <ReportContainerSelect isVisible={displayList}>
              <Label textColor={catalogs?.textTitleColor}>
                Mostrar Reportes
              </Label>
              <InputSelect
                value={reportsSelected}
                onChange={handleOnChangeReports}
              >
                {reportsSelect.map((item: any) => {
                  return (
                    <option key={"option_" + item.idVista} value={item.idVista}>
                      {item.descripcionMenu}
                    </option>
                  );
                })}
              </InputSelect>
            </ReportContainerSelect>

            <IconListButton
              bg={btnSimple?.background}
              onClick={() => setIconList(!iconList)}
            >
              {iconList ? (
                <Icon
                  style={{ color: styles.color, fontSize: styles.fontSize }}
                >
                  view_carousel
                </Icon>
              ) : (
                <Icon
                  style={{ color: styles.color, fontSize: styles.fontSize }}
                >
                  calendar_view_day
                </Icon>
              )}
            </IconListButton>
          </ReportContainerSelector>
          {isSelected && (
            <BackButton
              bg={btnSimple?.background}
              onClick={handleBackClick}
              selectOpen={displayList}
            >
              <Icon style={{ color: styles.color, fontSize: styles.fontSize }}>
                arrow_back
              </Icon>
            </BackButton>
          )}
        </ReportElementBanner>

        {renderSectionReport()}
      </div>
    </Layout>
  );
};

export default Reportes;
